<template>
  <div>
    <RevButton
      v-if="true"
      :data-qa="`mobile-plan-action-ask-for-help`"
      :disabled="false"
      full-width="always"
      variant="primary"
      @click="performAction"
    >
      Ask for help
    </RevButton>

    <RevPopover v-if="false">
      <template #trigger="{ show, hide }">
        <RevButton
          :data-qa="`mobile-plan-action-ask-for-help`"
          :disabled="false"
          full-width="always"
          variant="primary"
          @click="performAction"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        >
          Ask for help
        </RevButton>
      </template>

      <template #content="{ position }">
        <RevTooltip :position="position"> Hint message </RevTooltip>
      </template>
    </RevPopover>
  </div>
</template>

<script lang="ts" setup>
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'
import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'

import { ORDERLINE_CARD_MODAL } from '../../../../OrderlineCard.constants'

function performAction(): void {
  openModal(ORDERLINE_CARD_MODAL.mobilePlanAskForHelpModal)
}
</script>
